import { Suspense, lazy, useEffect, useState } from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import CryptoTicker from "@/components/landing/CryptoTicker";
import Features from "@/components/landing/Features";
import Exchanges from "@/components/landing/Exchanges";
import Pricing from "@/components/landing/Pricing";
import FloatingWhatsApp from "@/components/landing/FloatingWhatsApp";
import StickyRegisterBar from "@/components/landing/StickyRegisterBar";
import { useLanguage } from "@/contexts/LanguageContext";

// Below-the-fold sections are code-split to keep the mobile first paint light.
const Testimonials = lazy(() => import("@/components/landing/Testimonials"));
const Tutorial = lazy(() => import("@/components/landing/Tutorial"));
const FAQ = lazy(() => import("@/components/landing/FAQ"));
const BlogTeaser = lazy(() => import("@/components/landing/BlogTeaser"));
const CTA = lazy(() => import("@/components/landing/CTA"));
const Footer = lazy(() => import("@/components/landing/Footer"));

const Landing = () => {
  const { lang, t } = useLanguage();
  const [pastHero, setPastHero] = useState(false);

  useEffect(() => {
    document.title =
      lang === "id"
        ? "AIOTrade — Bot Trading Kripto Otomatis 24/7 (Terdaftar BAPPEBTI)"
        : "AIOTrade — All-in-One Automated Trading Tools";
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    const onScroll = () => setPastHero(window.scrollY > window.innerHeight * 0.75);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="landing-page"
      className="min-h-screen bg-[#050505] text-white relative"
    >
      <a href="#main-content" className="skip-link" data-testid="skip-to-content">
        {t.a11y.skip}
      </a>
      <Header />
      <main id="main-content" tabIndex={-1}>
        <Hero />
        <CryptoTicker />
        <Features />
        <Exchanges />
        <Pricing />
        <Suspense fallback={null}>
          <div className="defer-paint">
            <Testimonials />
            <Tutorial />
            <FAQ />
            <BlogTeaser />
            <CTA />
          </div>
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
      <FloatingWhatsApp pushedUp={pastHero} />
      <StickyRegisterBar visible={pastHero} />
    </div>
  );
};

export default Landing;
